import { RecoilRoot } from 'recoil';
import App from './App';

const Root = () => {
  return (
    <RecoilRoot>
      <App />
    </RecoilRoot>
  );
};

export default Root;
